export default class ProcessingActivityReadModel {
  ofRecipient(recipientId) {}
}
